import Global from '@/scripts/Global'
import VueSignals from '@/scripts/VueSignals'
import ChannelThumbNail from '@/components/LeftSidebar/ChannelThumbNail/ChannelThumbNail.vue';
export default {
    name: 'DefaultChannels',
    data: function() {
        return {}
    },
    props: {
        channels: Array,
        activeChannelDoc: Object,
        AlertedChannelsList: Array,
        arrMentions: Array,
        acceptedInvitationIds: Array,
        withMessagePreview: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatName(name) {
            return name ? (name.length >= 15 ? `${name.slice(0,15)}..` : name) : '';
        }
    },
    components:{
        ChannelThumbNail
    },
    methods: {
        loadChannel(channel_id) {
            Global.globalValue(VueSignals.LOADED_CHANNEL_ID, channel_id)
        }
    }
}
